//* Local or Custom Libraries
import { Button } from "@lululemon/ui-library";

//* Importing Styles
import styles from "../bopis-modal.module.scss";

/**
 * @param {object} activeStoreRadioBtn - an object containing id and name of the current selected store.
 * @param {boolean} isLoadingUserAddress - a boolean that determines if the user's address is loading.
 * @param {function} onSelectStoreClickHandler - a function that handles the store selection button click.
 * @param {array} nearbyBopisStores - an array that contains all nearby stores.
 * @param {object} searchQueryError - an error set from the geocodeAddress function if no address could be found.
 * @param {boolean} pdpShipBOPISRedesign - ABFlag for the New BOPIS redesign
 */
const BopisModalFooter = ({
  activeStoreRadioBtn,
  isLoadingUserAddress,
  isLoadingUserSearchQuery,
  nearbyBopisStores,
  onSelectStoreClickHandler,
  searchQueryError,
  selectedStore,
  pdpShipBOPISRedesign
}) => {
  const isStoreWithinDistance = nearbyBopisStores?.find(
    (store) => store.id === activeStoreRadioBtn?.id
  );
  const isActiveStoreDifferentThanSelectedStore =
    activeStoreRadioBtn?.id !== selectedStore?.id;
  const renderCondition =
    activeStoreRadioBtn?.id &&
    isStoreWithinDistance &&
    !isLoadingUserAddress &&
    !isLoadingUserSearchQuery &&
    isActiveStoreDifferentThanSelectedStore &&
    !searchQueryError;

  const redesignRenderCondition =
    !isLoadingUserAddress && !isLoadingUserSearchQuery;

  const shouldRenderButton = pdpShipBOPISRedesign
    ? redesignRenderCondition
    : renderCondition;
  const shouldDisableButton =
    pdpShipBOPISRedesign && !isActiveStoreDifferentThanSelectedStore;

  return (
    <div
      className={
        pdpShipBOPISRedesign
          ? styles.selectStoreButtonRedesign
          : styles.selectStoreButton
      }
    >
      {shouldRenderButton && (
        <Button
          aria-label="Select store"
          variant="filled"
          className={
            pdpShipBOPISRedesign ? styles.buttonRedesign : styles.button
          }
          disabled={shouldDisableButton}
          onClick={onSelectStoreClickHandler}
          block
        >
          {pdpShipBOPISRedesign ? "Select Store" : "Select"}
        </Button>
      )}
    </div>
  );
};

export default BopisModalFooter;
